export default __webpack_public_path__ + "static/media/NFO_PostLogin_Multi_Factor_Passive_FoF_Hero_Mobile.0c5ef10c.jpg";